/**
 * DOM utilities — helpers для работы с DOM, не зависящие от состояния класса.
 *
 * Phase 2 modularization Sprint 3 (2026-05-07).
 */
(function (global) {
    'use strict';

    /**
     * Debounce wrapper. Хранит timeoutId в переданной map.
     * @param {Object} timeoutIds - объект { [key]: timerId } для cleanup
     * @param {string} key - имя таймера
     * @param {Function} func - функция к вызову
     * @param {number} wait - delay в ms
     */
    function debounce(timeoutIds, key, func, wait) {
        if (timeoutIds[key]) clearTimeout(timeoutIds[key]);
        timeoutIds[key] = setTimeout(() => {
            try {
                func();
            } catch (e) {
                console.error(`[debounce:${key}]`, e);
            }
            timeoutIds[key] = null;
        }, wait);
    }

    /**
     * Показать notification (если в DOM есть элемент с id='notification').
     * @param {string} message
     * @param {boolean} isError
     */
    function showNotification(message, isError = false) {
        const notification = document.getElementById('notification');
        if (!notification) {
            console.warn('[Notification] DOM #notification not found:', message);
            return;
        }
        notification.textContent = message;
        notification.classList.toggle('error', !!isError);
        setTimeout(() => notification.classList.add('show'), 10);
        setTimeout(() => {
            notification.classList.remove('show');
        }, isError ? 4000 : 2500);
    }

    /**
     * Закрыть все открытые модалки (по селектору .modal.active или [data-modal=true]).
     */
    function closeAllModals() {
        document.querySelectorAll('.modal.active, .modal.show').forEach(el => {
            el.classList.remove('active', 'show');
        });
    }

    const DomUtils = {
        debounce,
        showNotification,
        closeAllModals
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = DomUtils;
    }
    if (global) {
        global.DomUtils = DomUtils;
    }
})(typeof window !== 'undefined' ? window : globalThis);
